<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UtKvbb/images/the-cutter.jpg?1734954345722" alt="This image is the cover for the book Cutter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cutter
      </h1>
      <p class="bookDescription body article font2">
        <b>In the eerie fog of Moorford Ridge, the past never truly dies . . .</b><br/><br/> Decades after the original Cutter murders terrorized Moorford Ridge, a new wave of killings begins, marked by the same chilling signature—a single word carved into flesh. Detective Sergeant Brady, a haunted man with a troubled past, is thrust into a nightmarish investigation that blurs the line between history and horror.<br/><br/> When a local historian becomes the prime suspect, Brady finds himself drawn into a twisted web of secrets that stretches back a century. As the body count rises, so do the stakes—and the detective is forced to confront his own demons while racing against time to unmask a killer born from the town’s darkest legends.<br/><br/> With each step, Brady uncovers truths that shake the very foundation of Moorford. But in a town where the past is still alive, can the detective stop the bloodshed before the Cutter claims another victim? Or will the shadows of history finally consume him?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Devine
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5335007c